import { GetterTree } from 'vuex';
import { CourseLocationState } from './types';
import { RootState } from '../../types';

export const getters: GetterTree<CourseLocationState, RootState> = {
  ['getCourseLocations']: (state) => state.courseLocations,
};
